export default __webpack_public_path__ + "static/media/designclear.7ed7beb1.png";